import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SpxButtonComponentModule } from "../../../shared/ui/spx-button/spx-button.component.module";
import { SupplierHomePage } from "./supplier-home.page";
import { SupplierHomePageRoutingModule } from "./supplier-home.page.routing.module";

@NgModule({
  imports: [
    CommonModule,
    SpxButtonComponentModule,
    SupplierHomePageRoutingModule,
  ],
  declarations: [SupplierHomePage],
  providers: [{ provide: Window, useValue: window }],
})
export class SupplierHomePageModule { }
